import { useDeviceType } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { CallBuilderContainer } from './CallBuilder';

import { ShowPhonesContainer } from './ShowPhones';

import {
  buildersWithPhonesSelector,
  isLeadFactorySelector,
  sellersWithPhonesSelector,
} from '../../selectors/newbuilding';

interface ICallToAction {
  placeType?: string;
  openAction?: string;
}

export function CallToActionContainer({ placeType, openAction }: ICallToAction) {
  const builders = useSelector(buildersWithPhonesSelector);
  const sellers = useSelector(sellersWithPhonesSelector);
  const leadFactorySeller = useSelector(isLeadFactorySelector);
  const deviceType = useDeviceType();

  if (builders.length + sellers.length === 0 && !leadFactorySeller) {
    return null;
  }

  const target = builders[0] || sellers[0];
  const isTargetBuilder = Boolean(builders[0]);
  const moreThanOnePhone = builders.length + sellers.length > 1;

  if (moreThanOnePhone || deviceType === 'tablet' || !!leadFactorySeller) {
    return (
      <ShowPhonesContainer
        builders={builders}
        sellers={sellers}
        leadFactorySeller={leadFactorySeller}
        placeType={placeType}
      />
    );
  }

  return (
    <CallBuilderContainer
      target={target}
      isTargetBuilder={isTargetBuilder}
      placeType={placeType}
      openAction={openAction}
    />
  );
}
